import { ILocation } from '@/services/types/core/locations/id';
import { IAction } from '@/utility/redux/action';

const GET_DEALER_LOCATION_REQUEST = 'dealerLocation/GET_DEALER_LOCATION_REQUEST';
const GET_DEALER_LOCATION_RESPONSE = 'dealerLocation/GET_DEALER_LOCATION_RESPONSE';
const GET_DEALER_LOCATION_FAILURE = 'dealerLocation/GET_DEALER_LOCATION_FAILURE';

interface IGetDealerLocationAction extends IAction {
  type: typeof GET_DEALER_LOCATION_REQUEST;
}
interface IGetDealerLocationResponseAction extends IAction {
  type: typeof GET_DEALER_LOCATION_RESPONSE;
  payload: ILocation;
}
interface IGetDealerLocationFailAction extends IAction {
  type: typeof GET_DEALER_LOCATION_FAILURE;
  payload: string;
  error: true;
}

type TAction =
  | IGetDealerLocationAction
  | IGetDealerLocationResponseAction
  | IGetDealerLocationFailAction;

interface IState {
  data?: ILocation;
  isLoading?: boolean;
  error?: string;
}

export const initialState: IState = {};

export default function reducer(state = initialState, action: TAction) {
  switch (action.type) {
    case GET_DEALER_LOCATION_REQUEST:
      return {
        ...state,
        data: undefined,
        isLoading: true,
        error: undefined,
      };
    case GET_DEALER_LOCATION_RESPONSE:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: undefined,
      };
    case GET_DEALER_LOCATION_FAILURE:
      return {
        ...state,
        data: undefined,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
